import { Action, Store } from 'redux';

import { RootState } from './store';
import {
  getPickingObjectInfo,
  isPickingActive,
  isPickingModeEasilyCancellable,
} from './store/selectors/pickingSelectors';
import { clearPickingObject, multiPickTypes } from './store/slices/applicationSlice';

function isExempt(targetElement: HTMLElement) {
  if (targetElement.id === 'scene-canvas') return true;

  if (targetElement.id.includes('reference-line-menu-item')) return true;

  if (
    targetElement.id.includes('select-cut-by-member-button') ||
    targetElement.id.includes('select-cut-by-line-button') ||
    targetElement.id.includes('delete-cut-button')
  ) {
    return true;
  }

  if (targetElement.classList.contains('clickable-during-picking')) {
    return true;
  }

  return false;
}

export function registerGlobalClickHandler(reduxStore: Store<RootState, Action>) {
  // Any click on an element that's not the scene or the reference line menu should cancel out of picking mode.
  document.addEventListener(
    'click',
    (event) => {
      const state = reduxStore.getState();
      if (!isPickingActive(state) || !isPickingModeEasilyCancellable(state)) return;

      if (reduxStore.getState().viewport.rightClickedItem?.type === 'referenceLine') return;

      let targetElement = event.target as HTMLElement | null;

      while (targetElement != null) {
        if (isExempt(targetElement)) return;

        targetElement = targetElement.parentElement;
      }

      const pickingObjectInfo = getPickingObjectInfo(state);
      if (!pickingObjectInfo || !multiPickTypes.includes(pickingObjectInfo.type))
        reduxStore.dispatch(clearPickingObject());
    },

    // We need to useCapture because this event handler must be called before the underlying element receives the event.
    //   Otherwise, clicking the "pick intersection" button, for example, would first turn on the picking mode and then
    //   it would immediately be turned back off by this event handler.
    { capture: true },
  );
}
